import rootVm from '@/main.js'
const axioslogins = {
  state: {
    Verification: 0

  },
  mutations: {
    add_Verification (state, Verification) {
      state.Verification = state.Verification + Verification
      if (state.Verification === 1) {
        // alert('登录已超时，请重新登录')
        rootVm.$confirm('对不起，您还没有登录？', '提示', {
          type: 'warning',
          confirmButtonText: '去登录',
          cancelButtonText: '再看看'
        }).then(() => {
          state.Verification = 0
          rootVm.$router.push({
            path: '/login/login'
          })
          return false
        }).catch(() => {
          state.Verification = 0
          rootVm.$router.go(-1)
          return false
        })
      }
    }
  },
  actions: {
    addVerification ({ commit }, data) {
      commit('add_Verification', data)
    // console.log(data);
    }
  },
  getters: {
    Verification: state => state.Verification
  }
}
export default axioslogins



// WEBPACK FOOTER //
// ./src/store/modules/axioslogin.js